import { Grid } from '@branchjs/neo-components';
import React from 'react';
import { SignupForm } from './SignupForm/SignupForm';
import { SignupPanel } from './SignupPanel/SignupPanel';

export function ScreenSignup() {
  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <SignupForm />
      </Grid>
      <Grid item xs={12} md={6}>
        <SignupPanel />
      </Grid>
    </Grid>
  );
}
